<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">GÉRARD LEHUGER</p>
                        <p class="green">CATTLE BREEDER IN PACÉ (35)</p>
                    </figcaption>
                </figure>

                <p class="number" :class="item.color">
                   €250 million 
                </p>

                <p class="green uppercase semiBold">
                    paid in claims to farmers hit by weather-related events.

                </p>

                <p class="number" :class="item.color">
                    60<sup>%</sup>
                </p>

                <p class="green uppercase semiBold">
                    of methanisation units in France are now insured by Groupama
                </p>


                <img class="icono w300" :src="require('../../assets/t1-mimosa.jpg')">
                <p class="label green">
                    MiiMOSA
                </p>

                <p class="green uppercase semiBold">
                    A crowdfunding platform to facilitate the process of economic transition for farms.

                </p>
				 <iframe width="560" height="200" src="https://www.youtube.com/embed/lEzJETJDjvc" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>

            </section>

            <section>
			<svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>

				<h2>We're better and stronger when we all work together</h2>

                <h1>   
                    <span>Acting with</span>
                    <span>Gérard for the benefits</span>
                    <span>of all the <em :class="item.color">farmers</em></span>
                </h1>




                <!--<h3>
                    à la tête d'une exploitation<br>
                    de 350 HA, en blé, colza et orge
                </h3>-->

                <p>
                    Gérard has been gripped by a passion for agriculture since childhood. Now a beef farmer in Montgermont, north-east of Rennes, he joined the family farm in 1985, and has run it since 1998. 
                     <br><br>
                    Blondes d’Aquitaine, Limousines and Charolais... Gérard takes great care over selecting the origin of his animals, which he buys from local breeders. He pays particularly close attention to herd nutrition, combining pasture grazing with feed grown on his own farm. This consistently demanding approach has allowed him to develop this family farm and its reputation nationally and contractually. Gérard has been marketing his high-quality meat direct to the public since 2005. He is absolutely convinced that effective selling demands human contact. <br><br>
Short supply chain, local channels, new technologies... Gérard is very much a farmer of today, combining tradition with the latest developments in agriculture. He was involved in the test phase of 
                    <a href="https://www.groupama.fr/assurance-agricole/application-gari" style="text-decoration: none" target="_blank" class="marker" :class="item.color">Gari</a>, the agricultural assistant launched by Groupama at the 2019 Paris International Agricultural Show, and has been using it for the past two years. This mobile app lets him keep a close daily eye on his livestock and farm “with complete peace of mind and confidence” from his smartphone using a single screen, not only in France, but also in some other countries as well. 
					<br><br>
					Closely involved in local life, Gérard isn’t just a member customer, but also a Groupama elected representative with “a visceral and local commitment” that naturally led him to become Chairman of his local mutual in Pacé. Like his relationship with Groupama, his business is built around a network of sharing and mutual aid, because Gérard is in absolutely no doubt that: “We're better and stronger when we all work together”.

                </p>
                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>To learn more about the facts that marked our year</p>
                        <p><span>DOWNLOAD</span> THE ANNUAL REPORT</p>
                    </div>
                </a>
            </section>
        </article>


    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>

<style scoped lang="scss">


</style>
